import Hls from 'hls.js';
import { HLS_SUPPORT } from '@videotools/js/components/player/enums';

const getHlsSupport = () => {
	const hlsSupport = Hls.isSupported();
	const testVideoElement = document.createElement('video');
	const hasNativeHLSSupport = testVideoElement.canPlayType('application/vnd.apple.mpegurl');
	if (hlsSupport && hasNativeHLSSupport) {
		return HLS_SUPPORT.SUPPORTED_NATIVE_AND_MSE;
	}
	if (hlsSupport) {
		return HLS_SUPPORT.SUPPORTED_MSE;
	}
	if (hasNativeHLSSupport) {
		return HLS_SUPPORT.SUPPORTED_NATIVE;
	}
	return HLS_SUPPORT.UNSUPPORTED;
};

const getAudioTrackListSupport = () => {
	const testVideoElement = document.createElement('video');
	return testVideoElement.audioTracks !== undefined;
};

const standardSupportsPiP = () => {
	return !!document.pictureInPictureEnabled;
};

const iosSupportsPiP = (videoElement) => {
	if (!videoElement) return false;
	return (
		typeof videoElement.webkitSetPresentationMode === 'function' &&
		typeof videoElement.webkitSupportsPresentationMode === 'function' &&
		videoElement.webkitSupportsPresentationMode('picture-in-picture')
	);
};

const getPictureInPictureSupport = (videoElement = null) => {
	// Standard PiP API
	const standardPiPAvailable = standardSupportsPiP();

	// iOS webkit API (requires video element)
	const iosPiPAvailable = iosSupportsPiP(videoElement);

	return standardPiPAvailable || iosPiPAvailable;
};

const iosIsInPiP = (videoElement) => {
	if (!videoElement) return false;
	// "inline" | "picture-in-picture" | "fullscreen" (values vary by iOS version)
	return videoElement.webkitPresentationMode === 'picture-in-picture';
};

const togglePictureInPicture = async(videoElement) => {
	if (!videoElement) return;

	// iOS webkit API - check support first
	if (iosSupportsPiP(videoElement)) {
		try {
			// Optional but improves reliability
			if (videoElement.paused) {
				try {
					await videoElement.play();
				} catch (e) {
					// autoplay/user settings
				}
			}
			videoElement.webkitSetPresentationMode(
				iosIsInPiP(videoElement) ? 'inline' : 'picture-in-picture'
			);
		} catch (error) {
			console.error('Error toggling iOS picture-in-picture:', error);
		}
		return;
	}

	// Standard PiP API
	if (!standardSupportsPiP()) {
		return;
	}

	try {
		if (document.pictureInPictureElement) {
			await document.exitPictureInPicture();
		} else {
			await videoElement.requestPictureInPicture();
		}
	} catch (error) {
		console.error('Error toggling picture-in-picture:', error);
	}
};

export default {
	getHlsSupport,
	getAudioTrackListSupport,
	getPictureInPictureSupport,
	iosSupportsPiP,
	iosIsInPiP,
	togglePictureInPicture,
};
